import { format } from 'date-fns';
import { isTest } from '@legacy/utils/env';

import { tlpBase } from '@/utils/gateway';

export const getUserAvatar = (userId: string | number) =>
  isTest
    ? undefined
    : `${tlpBase()}/Settings/UserSettings/DisplayProfilePicture?userID=${userId}&refresh=False&timespan=${format(
        new Date(),
        'yyyyMMddhh',
      )}`;
